import { render, staticRenderFns } from "./modal_pagar_comandas.vue?vue&type=template&id=12cbf616&scoped=true"
import script from "./modal_pagar_comandas.vue?vue&type=script&lang=js"
export * from "./modal_pagar_comandas.vue?vue&type=script&lang=js"
import style0 from "./modal_pagar_comandas.vue?vue&type=style&index=0&id=12cbf616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cbf616",
  null
  
)

export default component.exports